import Experience from "../Experience";
import * as THREE from "three";

export default class Particles {
    constructor() {
        // Options
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.time = this.experience.time
        this.resources = this.experience.resources
        this.texture = this.experience.resources.items.snow

        this.particlesNumberStart = 40000
        this.isFirstTime = true;

        this.setParticles(this.particlesNumberStart)
    }

    setParticles(particlesNumber) {
        this.particlesMaterial = new THREE.PointsMaterial()
        this.particlesMaterial.map = this.texture
        this.particlesMaterial.transparent = true
        this.particlesMaterial.alphaMap = this.texture
        
        this.particlesMaterial.size = 10;
        this.particlesMaterial.sizeAttenuation = false

        
        this.particlesGeometry = new THREE.BufferGeometry()

        this.positions = new Float32Array(particlesNumber * 3)
        this.velocity = new Float32Array(particlesNumber)

        for (let i = 0; i < particlesNumber; i++) {
            this.i3 = i * 3;
            this.positions[this.i3 + 0] = (Math.random() - 0.5) * 150
            if (this.isFirstTime) {
                this.positions[this.i3 + 1] = (Math.random() - 0.2) * 30
            } else {
                this.positions[this.i3 + 1] = 30
            }
            this.positions[this.i3 + 2] = (Math.random() - 0.5) * 150

            this.velocity[i] = (Math.random() + 0.1) * 0.006
        }

        this.particlesGeometry.setAttribute(
            "position",
            new THREE.BufferAttribute(this.positions, 3)
        );

        this.particles = new THREE.Points(this.particlesGeometry, this.particlesMaterial)

        this.scene.add(this.particles)
    }

    update() {
        const positions = this.particlesGeometry.attributes.position.array

        for (let i = 0; i < this.velocity.length; i++) {
            const i3 = i * 3;

            positions[i3 + 1] -= this.velocity[i]
            positions[i3 + 0] += this.velocity[i] * 0.6

            if (positions[i3 + 1] < - 10) {
                positions[i3 + 1] = 30
            }
        }
        this.particlesGeometry.attributes.position.needsUpdate = true
    }
}
